<div id="vidflare-container">
	<!-- element that the vidflare player will be appended to -->
	<div id="vidflare-loading">{{ 'video.preview.loading' | msgKeyCached }}</div>
</div>